import { useState } from 'react'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { CompetencyGroupsDataTable } from './CompetencyGroupsDataTable'
import { NewCompetencyGroupModal } from './NewCompetencyGroupModal'

const CompetenciesGroups = () => {
  const [showNewCompetencyGroupModal, setShowNewCompetencyGroupModal] = useState(false)

  return (
    <ResponsivePage.Body>
      <CompetencyGroupsDataTable
        onNewCompetencyGroup={() => setShowNewCompetencyGroupModal(true)}
      />

      {showNewCompetencyGroupModal && (
        <NewCompetencyGroupModal onClose={() => setShowNewCompetencyGroupModal(false)} />
      )}
    </ResponsivePage.Body>
  )
}

export default CompetenciesGroups
